// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TqaP6","title":"styles_title__36yAn"};